/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Status } from "./merchant";

export interface WorldpayUnderwritingStatus {
  status: Status;
  reason: string;
}
